import {
  AddLocationAltIcon,
  BarChartIcon,
  CalculatorIcon,
  CategoryIcon,
  ItemsIcon,
  ListIcon,
  ModuleManagementIcon,
  PeopleIcon,
  ShieldLockIcon,
  ViewTimelineIcon,
} from "@rothoblaas/design-system";
import { AuthContextType } from "../context/authContext";
import { Translation } from "../hooks/useTranslations";
import { Glyph } from "../types";

type Permissions = AuthContextType["permissions"];

export type AdminMenuEntry = {
  path: string;
  icon: Glyph;
  permission: keyof Permissions["admin"];
  getTitle: (translation: Translation) => string;
  getDescription: (translation: Translation) => string;
};

// Single source for the admin menu and the admin dashboard cards.
export const adminMenuEntries: AdminMenuEntry[] = [
  {
    path: "/admin/projects",
    icon: ListIcon,
    permission: "canManageProjects",
    getTitle: (t) => t.projects.all,
    getDescription: (t) => t.adminDashboard.projects,
  },
  {
    path: "/admin/calculations",
    icon: CalculatorIcon,
    permission: "canManageCalculations",
    getTitle: (t) => t.calculations.all,
    getDescription: (t) => t.adminDashboard.calculations,
  },
  {
    path: "/admin/modules",
    icon: ModuleManagementIcon,
    permission: "canManageModules",
    getTitle: (t) => t.modules.plural,
    getDescription: (t) => t.adminDashboard.modules,
  },
  {
    path: "/admin/categories",
    icon: CategoryIcon,
    permission: "canManageCategories",
    getTitle: (t) => t.categories.plural,
    getDescription: (t) => t.adminDashboard.categories,
  },
  {
    path: "/admin/items",
    icon: ItemsIcon,
    permission: "canManageItems",
    getTitle: (t) => t.items.all,
    getDescription: (t) => t.adminDashboard.items,
  },
  {
    path: "/admin/clients",
    icon: ViewTimelineIcon,
    permission: "canManageClients",
    getTitle: (t) => t.clients.plural,
    getDescription: (t) => t.adminDashboard.clients,
  },
  {
    path: "/admin/users",
    icon: PeopleIcon,
    permission: "canManageUsers",
    getTitle: (t) => t.users.plural,
    getDescription: (t) => t.adminDashboard.users,
  },
  {
    path: "/admin/access-control",
    icon: ShieldLockIcon,
    permission: "canManageAccessControl",
    getTitle: (t) => t.accessControl.plural,
    getDescription: (t) => t.adminDashboard.accessControl,
  },
  {
    path: "/admin/geo-blocking",
    icon: AddLocationAltIcon,
    permission: "canManageGeoBlocking",
    getTitle: (t) => t.geoBlocking.plural,
    getDescription: (t) => t.adminDashboard.geoBlocking,
  },
  {
    path: "/admin/usage-statistics",
    icon: BarChartIcon,
    permission: "canManageUsageStatistics",
    getTitle: (t) => t.usageStatistics.plural,
    getDescription: (t) => t.adminDashboard.usageStatistics,
  },
];

export const getAllowedAdminMenuEntries = ({ admin }: Permissions) =>
  adminMenuEntries.filter((entry) => admin[entry.permission]);

export const hasAdminPermissions = (permissions: Permissions) => getAllowedAdminMenuEntries(permissions).length > 0;
